import React from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import Unity, { RegisterExternalListener, UnityEvent } from 'react-unity-webgl';

import * as actions from '../../actions/index';
import icons from '../../data/icons';

import './Digital360.css';

class Digital360 extends React.Component {
  constructor(props) {
    super(props);
    this.onProgress = this.onProgress.bind(this);
    this.turnOffCamera = new UnityEvent('CameraLink', 'TurnOff', '');
    RegisterExternalListener('ShowCollaboration', () => this.props.setModal(4));
    RegisterExternalListener('ShowVR', () => this.props.setModal(5));
    RegisterExternalListener('ShowHSE', () => this.props.setModal(6));
  }

  componentWillMount() {
    this.props.setLoader(true);
  }

  componentWillUnmount() {
    this.turnOffCamera.emit();
  }

  onProgress(progression) {
    if (progression === 1) {
      const timeout = setTimeout(() => {
        this.props.setLoader(false);
        clearTimeout(timeout);
      }, 3000); // hide black entry screen
    }
  }

  render() {
    return (
      <section className="digital360">
        <Unity
          src="./assets/Unity/01/Build/PGGI.json"
          loader="./assets/Unity/01/Build/UnityLoader.js"
          width="110%"
          onProgress={this.onProgress}
        />
        <img
          className="digital360__icon"
          src={icons.digitalThreeSixty.svg}
          alt="360"
        />
      </section>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setLoader: (bool) => {
      dispatch(actions.setLoader(bool));
    },
    setModal: (index) => {
      dispatch(actions.setModal(index));
    },
  };
}


Digital360.propTypes = {
  setLoader: propTypes.func.isRequired,
  setModal: propTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(Digital360);



// WEBPACK FOOTER //
// ./src/components/Digital360/Digital360.js